var exports = {
  "f": "x804f0401--6e81a1--expand",
};

module.exports = exports;
